import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMonsterComponent } from './simple-icons-monster.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMonsterComponent ],
    exports:      [ SimpleIconsMonsterComponent ],
    bootstrap:    []
})
export class SimpleIconsMonsterModule {}
